import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Pencil, MousePointerClick, ImagePlus, Send } from "lucide-react";
import { useContent } from "@/lib/content";

const PAGES = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Gallery", path: "/gallery" },
  { name: "Booking Etiquette", path: "/booking-etiquette" },
  { name: "Booking Inquiry", path: "/booking" },
  { name: "Tour Schedule", path: "/tour" },
  { name: "Exclusive Travel", path: "/travel" },
  { name: "Spoil Me", path: "/gifts" },
  { name: "Q&A / FAQ", path: "/faq" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" },
  { name: "Links", path: "/links" },
];

const STEPS = [
  { icon: MousePointerClick, text: "Click any headline, paragraph or button label and type to change it." },
  { icon: ImagePlus, text: "Hover any photo and hit “Change photo” to swap it from your gallery or upload." },
  { icon: Send, text: "Nothing goes live until you press “Publish changes” in the floating bar." },
];

export const LiveEditLauncher = () => {
  const navigate = useNavigate();
  const { enterEditMode } = useContent();
  const open = (path) => { enterEditMode(); navigate(path); };

  return (
    <div data-testid="admin-live-edit">
      <h1 className="font-heading text-3xl text-charcoal mb-2">Live Edit</h1>
      <p className="font-body text-stone-grey mb-8">Edit your real pages visually — exactly as visitors see them.</p>

      <div className="glass rounded-xl p-6 mb-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {STEPS.map(({ icon: Icon, text }) => (
          <div key={text} className="flex items-start gap-3">
            <span className="w-9 h-9 rounded-full bg-jade-soft flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-jade-text" /></span>
            <p className="font-body text-sm text-stone-grey leading-relaxed">{text}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PAGES.map((p) => (
          <div key={p.path} className="glass rounded-xl p-5 flex items-center justify-between gap-4">
            <div>
              <p className="font-heading text-lg text-charcoal">{p.name}</p>
              <p className="font-body text-xs text-taupe">{p.path}</p>
            </div>
            <Button size="sm" className="btn-primary" onClick={() => open(p.path)} data-testid={`live-edit-open-${p.path === "/" ? "home" : p.path.slice(1)}`}>
              <Pencil className="w-4 h-4 mr-2" /> Edit
            </Button>
          </div>
        ))}
      </div>
      <p className="font-body text-xs text-taupe mt-6">Tip: on the Spoil Me and Links pages you can also add, edit and remove links while in edit mode — those save instantly.</p>
    </div>
  );
};
